import HotspotGridItem from "./HotspotGridItem";

export default HotspotGridItem;
